import React from "react";
import { MaterialReactTable } from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import { Button, ListItemIcon } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { getColumns } from "./columnsData/columns";
// import { useFieldArray, useFormContext } from "react-hook-form";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { pairFields2 } from "../pairFields";
import {
  compactTableProps,
  smallerHeadCellProps,
} from "../../../../../../styles/muiProps";
import { secondAxios } from "../../../../../../api/axios";
import { computeShellUID } from "../../../../../../utils/pvUID";

const INDEPENDENT_HEAD_DIAMETER_COMPONENTS = new Set([
  "Flat Rectangular Head (L/B)",
  "Flat Rectangular Head (R/T)",
  "Flat Round Head (L/B)",
  "Flat Round Head (R/T)",
]);

const hasIndependentHeadDiameter = (component) =>
  INDEPENDENT_HEAD_DIAMETER_COMPONENTS.has(component);

const InputTable = (props) => {
  const { reRender, isLoading } = props;
  const {
    register,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();
  const { fields, append, update, remove } = useFieldArray({
    control,
    name: "DataGridView5",
  });
  const watchedRows = useWatch({
    control,
    name: "DataGridView5",
  });

  //save cell changes in table
  const handleSaveCell = (cell, value) => {
    console.log(cell.column.id);
    // Normalise empty numeric cells to 0 so InvElectron validation never sees ""
    const numericColumns = [
      "Diameter",
      "Can Length",
      "Long Seam",
      "Provided Thk",
      "Weight",
    ];
    let finalValue = value;
    if (
      numericColumns.includes(cell.column.id) &&
      (value === "" || value === null || value === undefined)
    ) {
      finalValue = 0;
    }

    setValue(`DataGridView5.${cell.row.index}.${cell.column.id}`, finalValue);
    // Changes in Diameter applied throughout Table. And in the other tabs
    if (cell.column.id === "Diameter") {
      const currentComponent = getValues(
        `DataGridView5.${cell.row.index}.Component`,
      );

      // Flat round/rectangular heads keep their own diameter and do not force all rows.
      if (hasIndependentHeadDiameter(currentComponent)) {
        reRender();
        return;
      }

      fields.forEach((field, index) => {
        const rowComponent = getValues(`DataGridView5.${index}.Component`);
        if (!hasIndependentHeadDiameter(rowComponent)) {
          setValue(`DataGridView5.${index}.${cell.column.id}`, finalValue);
        }
      });

      pairFields2["Inside/Outside Diameter"].forEach((field, index) => {
        const isRegistered = Object.keys(errors).some(
          (error) => error === field,
        );
        if (
          !isRegistered &&
          (field.includes("txt") || field.includes("Text"))
        ) {
          register(field);
        }
        if (field.includes("txt") || field.includes("Text"))
          setValue(field, finalValue);
      });
      reRender();
    } else if (cell.column.id === "Provided Thk") {
      fields.forEach((field, index) => {
        setValue(`DataGridView5.${index}.${cell.column.id}`, finalValue);
      });
      setValue("txt_PT_CSC", finalValue);
      setValue("txt_PT_EHC", finalValue);
      setValue("txt_SPT_NC1", finalValue);
      reRender();
    } else if (cell.column.id === "Can Length") {
      // Can Length is per-row — heads and shells each keep their own value
      reRender();
    } else if (cell.column.id === "Component") {
      let material = "";
      if (value.includes("Head")) material = getValues("ComboBox9") || "";
      else material = getValues("ComboBox11") || "";
      setValue(`DataGridView5.${cell.row.index}.Material`, material);
      // Auto-generate UID when component changes
      const projectTag = getValues("TextBox48") || "";
      const uid = computeShellUID(value, projectTag);
      setValue(`DataGridView5.${cell.row.index}.UID`, uid);
      reRender();
    } else
      setValue(`DataGridView5.${cell.row.index}.${cell.column.id}`, finalValue);
  };

  //delete row
  const handleDeleteRow = (index) => {
    console.log({ index });
    remove(index);
    reRender();
  };

  //create new row in table
  const handleCreateNewRow = (values) => {
    append({
      UID: "",
      Component: "",
      Diameter: getValues("txtVIDia") || 0,
      Material: "",
      "Can Length": 0,
      "Long Seam": 0,
      "Provided Thk": getValues("txt_PT_CSC") || 0,
      Weight: 0,
    });
  };

  return (
    <MaterialReactTable
      columns={getColumns(getValues)}
      data={fields}
      editDisplayMode="table"
      {...compactTableProps}
      {...smallerHeadCellProps}
      enableEditing
      enableColumnActions={false}
      enableRowActions
      positionActionsColumn="last"
      state={{
        isLoading,
        // showProgressBars: isLoading ? true : false
      }}
      muiTableHeadCellProps={({ cell }) => ({
        sx: {
          borderRight: "1px solid rgba(224,224,224,1)",
          backgroundColor: "hsla(250, 86%, 97%, 1)",
          fontSize: "16px",
          // display: "flex",
          // alignItems: "center",
          // px: 0,
          py: 1.4,
        },
      })}
      muiEditTextFieldProps={({ cell }) => ({
        //onBlur is more efficient, but could use onChange instead
        onBlur: (event) => {
          handleSaveCell(cell, event.target.value);
        },
        sx: {
          "& .MuiInputBase-input": {
            padding: "8.5px 8px",
            textAlign: "center",
          },
        },
      })}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          size: 5,
          muiTableHeadCellProps: {
            align: "center",
          },
        },
      }}
      renderBottomToolbarCustomActions={() => (
        <Button
          color="secondary"
          size="small"
          onClick={() => handleCreateNewRow()}
          variant="contained"
        >
          Add row
        </Button>
      )}
      renderRowActionMenuItems={({ row }) => [
        <MenuItem
          key={0}
          sx={{ m: 0 }}
          onClick={() => handleDeleteRow(row.index)}
        >
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          Delete
        </MenuItem>,
      ]}
    />
  );
};

export default InputTable;
